import React, { Component } from "react";
import { Grid, Col, Row, Button, Alert } from "react-bootstrap";
import "./SearchOptions.css";

class SearchOptions extends Component {
    getStyle(part, option) {

        return part.find(o => o.name === option.name).selected
            ? "info"
            : "default";
    }

    render() {
        const explainer = this.props.hideExplainer
            ? null
            : <Row>
                  <Col xs={12} className="text-center">
                      <Alert bsStyle="info">
                          {this.props.explainerMessage
                              ? this.props.explainerMessage
                              : <br />}
                      </Alert>
                  </Col>
              </Row>;

        const tabsInstance = (
            <Grid fluid={true}>
                {explainer}
                <Row>
                    <Col xs={6}>
                        <h4>Websites</h4>
                        {this.props.options.dataSet.map(dataSetOption => (
                            <Button
                                block
                                bsStyle={this.getStyle(
                                    this.props.options.dataSet,
                                    dataSetOption
                                )}
                                key={dataSetOption.name}
                                onClick={() =>
                                    this.props.handleOptionsChange(
                                        "dataSet",
                                        dataSetOption.name
                                    )}
                                onMouseOver={() =>
                                    this.props.handleOptionHover(
                                        "dataSet",
                                        dataSetOption.name
                                    )}
                                className={dataSetOption.plan}
                            >
                                {dataSetOption.name}
                            </Button>
                        ))}
                    </Col>
                    <Col xs={6}>
                        <h4>Page Scope</h4>
                        {this.props.options.scope.map(scopeOption => (
                            <Button
                                block
                                bsStyle={
                                    this.props.options.scope.find(
                                        option =>
                                            option.name === scopeOption.name
                                    ).selected
                                        ? "info"
                                        : "default"
                                }
                                className={scopeOption.plan}
                                key={scopeOption.name}
                                name={scopeOption.name}
                                onClick={() =>
                                    this.props.handleOptionsChange(
                                        "scope",
                                        scopeOption.name
                                    )}
                                onMouseOver={() =>
                                    this.props.handleOptionHover(
                                        "scope",
                                        scopeOption.name
                                    )}                                
                            >
                                {scopeOption.name}
                            </Button>
                        ))}
                    </Col>
                </Row>
            </Grid>
        );

        return this.props.visible
            ? <div
                  className={
                      this.props.inContainer ? "SearchOptionsContainer" : null
                  }
              >
                  <div className="SearchOptions">{tabsInstance}</div>
              </div>
            : null;
    }
}

export default SearchOptions;



// WEBPACK FOOTER //
// ./src/SearchOptions.js